import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, updated, children, testId }) => (
  <div className="bg-[#F7F2EA] min-h-screen" data-testid={testId}>
    <div className="max-w-3xl mx-auto px-6 pt-12 pb-24">
      <Link
        to="/"
        data-testid="legal-back-link"
        className="inline-flex items-center gap-2 text-sm text-[#2B1930]/60 hover:text-[#D83A52] transition-colors mb-10"
      >
        <ArrowLeft className="h-4 w-4" /> Torna alla home
      </Link>
      <p className="text-xs uppercase tracking-[0.35em] font-bold text-[#C8A6A1] mb-3">Documento legale</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-[#2B1930] leading-[1.1] mb-2">{title}</h1>
      <p className="text-sm text-[#181518]/50 mb-10">Ultimo aggiornamento: {updated}</p>
      <div className="pv-prose">{children}</div>
    </div>
    <Footer />
  </div>
);
